<template>
    <div class="btn btn-secondary btn-panel">
        <span>{{ name }}</span>
        <el-popover placement="top" trigger="hover">
            <div>
                <div>Size: {{ size }}</div>
                <div>Type: {{ type }}</div>
                <div>Duration: {{ duration }}</div>
            </div>
            <i slot="reference" class="fas fa-info-circle cursor-pointer ml-1"/>
        </el-popover>
        <el-popover v-if="canPlay" content="Play" trigger="hover" placement="top" popper-class="text-center">
            <i slot="reference" class="fas fa-play cursor-pointer ml-1" @click="play"/>
        </el-popover>
        <el-popover v-if="canStop" content="Stop" trigger="hover" placement="top" popper-class="text-center">
            <i slot="reference" class="fas fa-stop cursor-pointer ml-1" @click="stop"/>
        </el-popover>
        <el-popover v-if="canRemove" content="Remove" trigger="hover" placement="top" popper-class="text-center">
            <i slot="reference" class="far fa-times-circle cursor-pointer ml-1" @click="remove"/>
        </el-popover>
    </div>
</template>

<script>
  import {formatMemory} from "../../helpers";

  const states = {
    play: 'play',
    stop: 'stop',
  };

  export default {
    props: {
      metadata:Object,
      url: String,
      removable: Boolean,
    },

    data() {
      return {
        player: new Audio(this.url),
        duration: '-',
        state: states.stop,
      }
    },

    computed: {
      /**
       * @return string
       */
      size() {
        const val = _.get(this.metadata, 'size');

        return val ? formatMemory(val) : '-';
      },

      /**
       * @return string
       */
      type() {
        return  _.get(this.metadata, 'type', '-');
      },

      /**
       * @return string
       */
      name() {
        return  _.get(this.metadata, 'filename', '-');
      },

      /**
       * @return {boolean}
       */
      canPlay() {
        return this.state === states.stop;
      },

      /**
       * @return {boolean}
       */
      canStop() {
        return this.state === states.play;
      },

      /**
       * @return {Boolean}
       */
      canRemove() {
        return this.removable;
      }
    },

    methods: {
      /**
       * @emits remove
       */
      remove() {
        this.$emit('remove')
      },

      /**
       * @return {undefined}
       */
      play() {
        this.player.play();
      },

      /**
       * @return {undefined}
       */
      stop() {
        this.player.pause();
        this.player.currentTime = 0;
      },

      /**
       * @return {undefined}
       */
      onPlayerPlay() {
        this.state = states.play;
      },

      /**
       * @return {undefined}
       */
      onPlayerPause() {
        this.state = states.stop;
      },

      /**
       * @return {undefined}
       */
      loadedMetadata(e) {
        this.duration = this.getDuration(e);
      },

      /**
       * @param e
       * @return {string}
       */
      getDuration(e) {
        const seconds = _.get(e, 'path.0.duration');
        return _.isNumber(seconds)
          ? moment.utc(seconds * 1000).format('HH:mm:ss')
          : '-';
      },
    },

    mounted() {
      this.player.addEventListener('play', this.onPlayerPlay);
      this.player.addEventListener('pause', this.onPlayerPause);
      this.player.addEventListener('loadedmetadata', this.loadedMetadata);
    },

    beforeDestroy() {
      this.player.pause();
      this.player.removeEventListener('play', this.onPlayerPlay);
      this.player.removeEventListener('pause', this.onPlayerPause);
      this.player.removeEventListener('loadedmetadata', this.loadedMetadata);
    },
  }
</script>
